import * as React from 'react';
import { Grid, Button, Theme, makeStyles } from '@material-ui/core';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { FormHelperText } from '@material-ui/core';

export interface SelectItemType {
    value: number | string,
    text: string,
};


const useStyles = makeStyles((theme: Theme) => ({
    whiteColor: {
        color: "white"
    },
    helpText: {
        color: 'red',
        padding: theme.spacing(0, 0, 0, 2)
    },
    selectDropdown: {
        maxWidth: '300px',
        widht: "100%",
        backgroundColor: '#0F233A', 
        color: 'white', 
        fill: 'white'
    }
}));

const DropdownSelectOption = ({ title, itemsList, isError, errorText, selectedValue, onChange }:
    { title: string, isError?: boolean, errorText?: string, itemsList: SelectItemType[], selectedValue: string | number | null, onChange: (v: string | number) => void }) => {
    const classes = useStyles();

    return (
        <>
            <Grid xs={12} item style={{ paddingTop: 40 }}>
                <div style={{ fontSize: 24, color: 'white' }}>
                    {title}
                </div>
            </Grid>
            <Grid xs={12} item style={{ paddingTop: 20 }}>
                <Select
                    fullWidth={true}
                    value={selectedValue}
                    variant="outlined"
                    classes={{
                        icon: classes.whiteColor
                    }}
                    displayEmpty
                    className={classes.selectDropdown}
                    error={isError}
                    onChange={(e: any) => onChange(e.target.value)} >
                    {
                        itemsList.map((item: SelectItemType) => <MenuItem key={item.value} value={item.value}>{item.text}</MenuItem >)
                    }
                </Select>
                {isError && errorText && <FormHelperText className={classes.helpText}>{errorText}</FormHelperText>}
            </Grid>
        </>)
}

export default React.memo(DropdownSelectOption);